import script from "./EInputPhone.vue?vue&type=script&lang=ts&setup=true"
export * from "./EInputPhone.vue?vue&type=script&lang=ts&setup=true"

import "./EInputPhone.vue?vue&type=style&index=0&id=b9987c3c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b9987c3c"]])

export default __exports__